module.exports = __webpack_public_path__ + "img/timeline-03.43111d35.jpg";